import { render, staticRenderFns } from "./CalendarLoader.vue?vue&type=template&id=0406c9c7&scoped=true"
import script from "./CalendarLoader.vue?vue&type=script&lang=js"
export * from "./CalendarLoader.vue?vue&type=script&lang=js"
import style0 from "./CalendarLoader.vue?vue&type=style&index=0&id=0406c9c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406c9c7",
  null
  
)

export default component.exports